
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/vejr",
      function () {
        return require("private-next-pages/[region]/[resort]/vejr.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/vejr"])
      });
    }
  